import { State } from "./state";
import { GetterTree } from "vuex";

export default {
  tenants: (state: State) => state.tenants,

} as GetterTree<State, any>;
